import React, { forwardRef } from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Button as EvergreenButton } from 'evergreen-ui';

import styles from './Button.module.scss';

const types = {
  primary: 'primary',
  default: 'default',
  minimal: 'minimal',
  link: 'link',
};

const Button = forwardRef(({
  children,
  onClick,
  type,
  htmlType,
  loading,
  disabled,
  initialCase,
  className,
  iconBefore,
  iconAfter,
  height,
  textTransform,
  ...props
}, ref) => (
  <EvergreenButton
    ref={ref}
    type={htmlType}
    onClick={onClick}
    className={cn(
      styles.button,
      {
        [styles.primary]: type === types.primary,
        [styles.default]: type === types.default,
        [styles.minimal]: type === types.minimal,
        [styles.link]: type === types.link,
        [styles.initialCase]: !!initialCase,
        [styles.iconBefore]: !!iconBefore,
      },
      className,
    )}
    appearance={type}
    isLoading={loading}
    disabled={disabled}
    height={height}
    iconBefore={!loading ? iconBefore : null}
    iconAfter={iconAfter}
    textTransform={textTransform}
    {...props}
  >
    {children}
  </EvergreenButton>
));

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  type: PropTypes.oneOf(Object.values(types)),
  htmlType: PropTypes.string,
  loading: PropTypes.bool,
  disabled: PropTypes.bool,
  initialCase: PropTypes.bool,
  className: PropTypes.string,
  iconBefore: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.elementType,
    PropTypes.oneOf([null, false])
  ]),
  iconAfter: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.func,
    PropTypes.elementType,
    PropTypes.oneOf([null, false])
  ]),
  height: PropTypes.number,
  textTransform: PropTypes.string,
};

Button.defaultProps = {
  onClick: null,
  type: types.primary,
  htmlType: 'button',
  loading: false,
  disabled: false,
  initialCase: false,
  className: null,
  iconBefore: null,
  iconAfter: null,
  height: 44,
  textTransform: 'uppercase',
};

export default React.memo(Button);
